import { createStore, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';

import searchReducer from './reducers/userReducer';
import userReducer from './reducers/userReducer';
import cfgReducer from './reducers/cfgReducer';
import pinReducer from './reducers/pinReducer';
import impersonateReducer from './reducers/impersonateReducer';
import impersonateModeModalReducer from './reducers/impersonateModeModalReducer';
import cashFlowModalReducer from './reducers/cashFlowModalReducer';
import redirectingToDocuSignReducer from './reducers/redirectingToDocuSignReducer';
import docuSignReducer from './reducers/docuSignReducer';
import investorReducer from './reducers/investorReducer';
import multipleDownloadReducer from './reducers/multipleDownloadReducer';
import boardsReducer from './reducers/boardsReducer';
import serverErrorReducer from './reducers/serverErrorReducer';
import sidebarReducer from './reducers/sidebarReducer';
import pdfReducer from './reducers/pdfReducer';

let rootReducer = combineReducers({
  search: searchReducer,
  user: userReducer,
  cfg: cfgReducer,
  pin: pinReducer,
  pdf: pdfReducer,
  impersonate: impersonateReducer,
  impersonateModeModal: impersonateModeModalReducer,
  cashFlowModal: cashFlowModalReducer,
  redirectingModal: redirectingToDocuSignReducer,
  docuSignDropdown: docuSignReducer,
  investor: investorReducer,
  multipleDownload: multipleDownloadReducer,
  board: boardsReducer,
  serverError: serverErrorReducer,
  sidebar: sidebarReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

const store = createStore(rootReducer, composeWithDevTools());

export default store;
